import type { OrderDetailsOrder } from '@/types/orderDetailsOrder';

import type { UserFragment } from '@/graphql/saleor/api';
import { ACCOUNT_METADATA } from '@/lib/metadata/const';
import { getMetaValue } from '@/lib/metadata/helpers';
import { handlePhonePrefix } from '@/lib/phonePrefixes/helpers';
import type { CheckoutState } from '@/states/checkout';

/** @TODO : Might be good to move this util out of the views folder */
export const getContactPhone = (
  order?: CheckoutState<true>['checkout'] | OrderDetailsOrder,
  user?: Partial<UserFragment> | null,
) => {
  const phone = order?.billingAddress?.phone ?? order?.shippingAddress?.phone;
  if (!phone && user) {
    const userPhonePrefix = handlePhonePrefix(
      getMetaValue(user?.metadata ?? [], ACCOUNT_METADATA.phonePrefix) ?? '',
    );
    const userPhoneNumber = getMetaValue(
      user?.metadata ?? [],
      ACCOUNT_METADATA.phone,
    );

    const userPhone = `${userPhonePrefix}${userPhoneNumber}`;

    return userPhoneNumber !== '' && userPhonePrefix !== '' ? userPhone : phone;
  }

  return phone;
};
